import ksBridge from '@ks/ks-bridge';
// import { setWeblog } from '../util/util.js';
const logsamplerate: any = {
    logSampleRate: 0.1
};
ksBridge.config(logsamplerate);
// setWeblog();
export default ksBridge;
